export const CategoryType = {
  InteractiveObject: 'InteractiveObject',
}

export const CategoryTypeWording = {
  [CategoryType.InteractiveObject]: '互動物件'
}